import type { SVGProps } from "react";
const SenecPictogramSociety = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 9C7.23858 9 5 11.2386 5 14C5 16.7614 7.23858 19 10 19C12.7614 19 15 16.7614 15 14C15 11.2386 12.7614 9 10 9ZM7 14C7 12.3431 8.34315 11 10 11C11.6569 11 13 12.3431 13 14C13 15.6569 11.6569 17 10 17C8.34315 17 7 15.6569 7 14Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38 9C35.2386 9 33 11.2386 33 14C33 16.7614 35.2386 19 38 19C40.7614 19 43 16.7614 43 14C43 11.2386 40.7614 9 38 9ZM35 14C35 12.3431 36.3431 11 38 11C39.6569 11 41 12.3431 41 14C41 15.6569 39.6569 17 38 17C36.3431 17 35 15.6569 35 14Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.5048 16.6661C20.0077 17.53 19 19.1473 19 21C19 23.7614 21.2386 26 24 26C26.7614 26 29 23.7614 29 21C29 19.1473 27.9923 17.53 26.4952 16.6661C26.814 16.1895 27 15.6165 27 15C27 13.3431 25.6569 12 24 12C22.3431 12 21 13.3431 21 15C21 15.6165 21.186 16.1895 21.5048 16.6661ZM24 18C22.3431 18 21 19.3431 21 21C21 22.6569 22.3431 24 24 24C25.6569 24 27 22.6569 27 21C27 19.3431 25.6569 18 24 18ZM24 16C24.5523 16 25 15.5523 25 15C25 14.4477 24.5523 14 24 14C23.4477 14 23 14.4477 23 15C23 15.5523 23.4477 16 24 16Z"
            fill="currentColor"
        />
        <path
            d="M10 21C5.58172 21 2 24.5817 2 29V33H4V29C4 25.6863 6.68629 23 10 23C13.3137 23 16 25.6863 16 29C16 29.5523 16.4477 30 17 30C17.5523 30 18 29.5523 18 29C18 24.5817 14.4183 21 10 21Z"
            fill="currentColor"
        />
        <path
            d="M38 21C33.5817 21 30 24.5817 30 29C30 29.5523 30.4477 30 31 30C31.5523 30 32 29.5523 32 29C32 25.6863 34.6863 23 38 23C41.3137 23 44 25.6863 44 29V33H46V29C46 24.5817 42.4183 21 38 21Z"
            fill="currentColor"
        />
        <path
            d="M19 35C19 32.2386 21.2386 30 24 30C26.7614 30 29 32.2386 29 35V39H31V35C31 31.134 27.866 28 24 28C20.134 28 17 31.134 17 35V39H19V35Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramSociety;
